"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxRedeemableLoyaltyInCents = exports.convertCentsToLoyaltyPoints = exports.convertLoyaltyPointsToCents = void 0;
const constants_1 = require("../constants");
const convertLoyaltyPointsToCents = (loyaltyPoints, loyaltyPointsMultiplier) => {
    if (loyaltyPointsMultiplier === undefined) {
        loyaltyPointsMultiplier = 100;
    }
    return Math.floor(loyaltyPoints * (loyaltyPointsMultiplier / constants_1.LOYALTY_POINT_CONSTANT));
};
exports.convertLoyaltyPointsToCents = convertLoyaltyPointsToCents;
const convertCentsToLoyaltyPoints = (centValue, loyaltyPointsMultiplier) => {
    if (loyaltyPointsMultiplier === undefined) {
        loyaltyPointsMultiplier = 100;
    }
    else if (loyaltyPointsMultiplier === 0) {
        return 0;
    }
    return Math.ceil(Math.abs(centValue) / (loyaltyPointsMultiplier / constants_1.LOYALTY_POINT_CONSTANT));
};
exports.convertCentsToLoyaltyPoints = convertCentsToLoyaltyPoints;
const getMaxRedeemableLoyaltyInCents = (params) => {
    const maximumAllowedLoyaltyInCents = params.creditBalanceInCents === undefined
        ? params.subTotal
        : Math.min(params.subTotal, params.creditBalanceInCents);
    const minAllowableCannabisDiscountedPrice = 1 * params.complianceProductCount; // Each cannabis product must be sold at $0.01 or greater
    const subTotalAfterDiscount = params.subTotal - maximumAllowedLoyaltyInCents;
    const isDiscountedPriceBelowMinimum = subTotalAfterDiscount < minAllowableCannabisDiscountedPrice;
    return isDiscountedPriceBelowMinimum
        ? params.subTotal - minAllowableCannabisDiscountedPrice
        : maximumAllowedLoyaltyInCents;
};
exports.getMaxRedeemableLoyaltyInCents = getMaxRedeemableLoyaltyInCents;
//# sourceMappingURL=utilties.js.map